import { Component, Event, h, Prop, State, Watch } from '@stencil/core';
import { v4 as uuidv4 } from 'uuid';
import { VERSION_FORM_COMPONENTS } from "../shared/utils";
export class RadioGroup {
  constructor() {
    this.uuid = `a-radiogroup-${uuidv4()}`;
    this.version = VERSION_FORM_COMPONENTS;
  }
  handleInitialValueUpdate(newValue) {
    if (newValue && newValue !== this._value) {
      this._value = newValue;
      this.value = this._value;
    }
  }
  handleValueUpdate(newValue) {
    if (this._value !== newValue) {
      this._value = newValue;
    }
  }
  handleInternalValueUpdate(newValue) {
    if (this.value !== newValue) {
      this.value = newValue;
      this.valuechange.emit(this.value);
    }
  }
  handleKeyDown(entry, evt) {
    if (['Enter', 'Space'].includes(evt.code)) {
      this.handleValueUpdate(entry);
    }
  }
  handleClick(entry) {
    if (entry) {
      this.handleValueUpdate(entry);
    }
  }
  updateInternalValue() {
    if (this.value) {
      this._value = this.value;
    }
  }
  handleInitialValue() {
    if (this.initialvalue && this.initialvalue !== this._value) {
      this.value = this.initialvalue;
    }
  }
  componentWillLoad() {
    this.updateInternalValue();
    this.handleInitialValue();
    this._data = typeof this.data === 'string' ? JSON.parse(this.data) : this.data;
    this._labels = typeof this.labels === 'string' ? JSON.parse(this.labels) : this.labels;
    console.log(this._data);
    console.log(this._labels);
  }
  render() {
    return (h("div", { role: "radiogroup", id: this.uuid + 'radioGroup' }, this._data && this._data.map((entry, i) => {
      return (h("span", { onClick: () => this.handleClick(entry), onKeyDown: (evt) => this.handleKeyDown(entry, evt) },
        h("span", { id: this.uuid + '-radio' + i, tabindex: "0", role: "radio", "data-entry": entry, "aria-checked": !!this._value && this._value === entry ? 'true' : 'false', "aria-labelledby": this.uuid + '-radio' + i + '-label' },
          h("c-icon", { name: !!this._value && this._value === entry ? 'circleCheck' : 'circle' })),
        h("label", { id: this.uuid + '-radio' + i + '-label' }, this._labels && this._labels[entry] ? this._labels[entry] : entry)));
    })));
  }
  static get is() { return "a-radiogroup"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["a-radiogroup.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["a-radiogroup.css"]
  }; }
  static get properties() { return {
    "uuid": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "uuid",
      "reflect": false,
      "defaultValue": "`a-radiogroup-${uuidv4()}`"
    },
    "version": {
      "type": "string",
      "mutable": true,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "version",
      "reflect": true,
      "defaultValue": "VERSION_FORM_COMPONENTS"
    },
    "disabled": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "disabled",
      "reflect": true
    },
    "data": {
      "type": "any",
      "mutable": false,
      "complexType": {
        "original": "any",
        "resolved": "any",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "data",
      "reflect": false
    },
    "labels": {
      "type": "any",
      "mutable": false,
      "complexType": {
        "original": "any",
        "resolved": "any",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "labels",
      "reflect": false
    },
    "initialvalue": {
      "type": "any",
      "mutable": false,
      "complexType": {
        "original": "any",
        "resolved": "any",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "initialvalue",
      "reflect": true
    },
    "label": {
      "type": "any",
      "mutable": false,
      "complexType": {
        "original": "any",
        "resolved": "any",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "label",
      "reflect": true
    },
    "value": {
      "type": "string",
      "mutable": true,
      "complexType": {
        "original": "string | object",
        "resolved": "object | string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "value",
      "reflect": true
    }
  }; }
  static get states() { return {
    "_data": {},
    "_labels": {},
    "_value": {}
  }; }
  static get events() { return [{
      "method": "valuechange",
      "name": "valuechange",
      "bubbles": true,
      "cancelable": true,
      "composed": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "complexType": {
        "original": "any",
        "resolved": "any",
        "references": {}
      }
    }]; }
  static get watchers() { return [{
      "propName": "initialvalue",
      "methodName": "handleInitialValueUpdate"
    }, {
      "propName": "value",
      "methodName": "handleValueUpdate"
    }, {
      "propName": "_value",
      "methodName": "handleInternalValueUpdate"
    }]; }
}
